import { render, staticRenderFns } from "./PlannerGovernor.vue?vue&type=template&id=561392c6&scoped=true&"
import script from "./PlannerGovernor.vue?vue&type=script&lang=js&"
export * from "./PlannerGovernor.vue?vue&type=script&lang=js&"
import style0 from "./PlannerGovernor.vue?vue&type=style&index=0&id=561392c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561392c6",
  null
  
)

export default component.exports